import React, { useState } from "react";

import { useMediaQuery } from "react-responsive";
import Pagination from "../../../commanPage/pagination/Pagination";
const initialBitData = [
  {
    id: 1,
    productName: "Hi Chrome Scrap (Low Grade) Cement mill liner plates",
    quality: "40.00/MT",
    emd: "3,00,000.00",
    heighestBit: "8,00,000.00",
    myHighestBit: "6,00,000.00",
    status: "Win",
  },
  {
    id: 2,
    productName: "Hi Chrome Scrap (Low Grade) Cement mill liner plates",
    quality: "40.00/MT",
    emd: "3,00,000.00",
    heighestBit: "8,00,000.00",
    myHighestBit: "6,00,000.00",
    status: "Loss",
  },
  {
    id: 3,
    productName: "Hi Chrome Scrap (Low Grade) Cement mill liner plates",
    quality: "40.00/MT",
    emd: "3,00,000.00",
    heighestBit: "8,00,000.00",
    myHighestBit: "6,00,000.00",
    status: "Win",
  },
  {
    id: 4,
    productName: "Hi Chrome Scrap (Low Grade) Cement mill liner plates",
    quality: "40.00/MT",
    emd: "3,00,000.00",
    heighestBit: "8,00,000.00",
    myHighestBit: "6,00,000.00",
    status: "Win",
  },
  {
    id: 5,
    productName: "Hi Chrome Scrap (Low Grade) Cement mill liner plates",
    quality: "40.00/MT",
    emd: "3,00,000.00",
    heighestBit: "8,00,000.00",
    myHighestBit: "6,00,000.00",
    status: "Loss",
  },
];
function LotBitTable() {
  const totalNumberRow = 6;
  const isTablet = useMediaQuery({ query: "(max-width: 990px)" });
  const [bitData, setBitData] = useState([...initialBitData]);
  const [currentPage, setCurrentPage] = useState(0);
  return (
    <>
      <div className="table-container-style mt-1">
        <table
          className={`responsive-table centered ${
            isTablet ? "auction_table table-style" : "custom-table-style"
          } `}
        >
          <thead>
            <tr>
              <th>Lot No</th>
              <th>Product Name</th>
              <th>Quantity / UOM</th>
              <th>EMD Amount (Rs.)</th>
              <th>Highest bid</th>
              <th>My Highest bid</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {bitData?.map((items, index) => (
              <tr key={items.id}>
                <td>{items.id}</td>
                <td>{items.productName}</td>
                <td>{items.quality}</td>
                <td>{items.emd}</td>
                <td>{items.heighestBit}</td>
                <td>{items.myHighestBit}</td>
                <td>
                  <button
                    className={`button-style ${
                      items.status === "Win" ? "green-text" : "red-text"
                    } pointer`}
                    style={{
                      padding: "6px 40px",
                      border:
                        items.status === "Win"
                          ? "1px solid green"
                          : "1px solid red",
                      fontWeight: "600",
                      marginBottom: "5px",
                    }}
                  >
                    {items.status}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Pagination
        Data={bitData}
        totalNumberRow={totalNumberRow}
        setCurrentPage={setCurrentPage}
      />
    </>
  );
}

export default LotBitTable;
